export const TOP = '/';
export const TERMS = '/terms';
export const NOT_FOUND = '/404';
export const EXPIRED_URL = '/expired_url';
export const UNSUBSCRIBE_EMAIL = '/unsubscribe_email';
